export const topBanner = {
    type: "nested",
    label: "Top Banner",
    fields: {
        show: {
            type: "boolean",
            label: "Show top banner"
        },
        topBannerText: {
            type: "text",
            label: "Top Banner Text"
        },
        topBannerUrl: {
            type: "text",
            label: "Read More Url (optional)"
        }
    }
};
